import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 48 48"
  >
    <g className="stroke-change" fill="none" fillRule="evenodd" stroke="#9F9F9F">
      <g transform="rotate(-20 40.35 .65)">
        <circle cx="17" cy="17" r="15.5" strokeWidth="3" />
        <path
          className="fill-change"
          fill="#9F9F9F"
          d="M29.924 25.533l-6.685.054-2.117 6.341 8.802-6.395zm-25.848 0l8.802 6.395-2.117-6.34-6.685-.055zM29.11 7.346l-2.014 6.374 5.376 3.973L29.11 7.346zm-24.218 0L1.529 17.693l5.376-3.973-2.014-6.374zM22.44 2.5H11.56L17 6.386 22.44 2.5z"
        />
      </g>
      <path
        className="fill-change"
        fill="#9F9F9F"
        strokeWidth="3"
        d="M22.582 20.104l-2.725 4.04 3 3.841 4.58-1.667-.17-4.87-4.685-1.344z"
      />
    </g>
  </svg>
);
